import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { RawRESTClient } from 'src/apis/service';
import { EventGatewayContextService } from 'src/apis/service/EventGatewayContextService';
import { nextPagePropsAtom } from 'src/stores/pageProps/atoms';
import { EVENT_API_URL, EVENT_DEV_API_URL } from 'src/types/Event';
import { setEventGatewayOrigin } from 'src/utils/event-gateway';

export const useInitEventGateway = () => {
  const [service] = useState(() => new EventGatewayContextService(new RawRESTClient()));
  const pageProps = useAtomValue(nextPagePropsAtom);

  const { data } = useQuery({
    queryKey: ['eventGateway'],
    async queryFn() {
      return service.get({});
    },
    gcTime: Infinity,
    staleTime: Infinity,
    meta: {
      withoutAuth: true,
    },
    enabled: !pageProps?.isAPIUnavailable,
  });

  useEffect(() => {
    if (data) {
      setEventGatewayOrigin(data.url);
    } else if (pageProps?.isAPIUnavailable) {
      if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'Prod' && EVENT_API_URL) {
        setEventGatewayOrigin(EVENT_API_URL);
      } else {
        setEventGatewayOrigin(EVENT_DEV_API_URL);
      }
    }
  }, [data, pageProps?.isAPIUnavailable]);
};
